import { render, staticRenderFns } from "./RFQ.vue?vue&type=template&id=137f52ae&scoped=true&"
import script from "./RFQ.vue?vue&type=script&lang=js&"
export * from "./RFQ.vue?vue&type=script&lang=js&"
import style0 from "./RFQ.vue?vue&type=style&index=0&id=137f52ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f52ae",
  null
  
)

export default component.exports